import { getVisitorId } from './cookieUtils';
import {
  isPresent, retrieveItagData, retrieveOmnData, getDigitalData, getReferrerType,
  isDTMLoaded, triggerGCTCall, decodeVeidStr, getDate, getRandomGuid,
} from './commonUtils';
import {
  INTERNAL_DOMAINS_DOMESTIC, ITAG_ARR_DOMESTIC, OMN_ARR_DOMESTIC, OMN_OBJ_ARR_DOMESTIC,
} from './constants';
import { makeRequest } from './makeRequest';

export const campaignDomesticData = {
  envUrl: process.env.GLOBAL_CAMPAIGN_FAAS_URL,
  gctDataArr: ['', '', '', '', '', ''],
  isGCTSupportedEvent: false,
  queryParamsMap: new Map(),
  digitalData: '',
};

export const initialize = () => {
  if (window.document.cookie.indexOf('gctracus') < 0) {
    return getDate() + getRandomGuid();
  }
  return getVisitorId('US');
};

export const setRVData = (rvData) => {
  if (isPresent(rvData.Partner)) campaignDomesticData.queryParamsMap.set('Partner', encodeURIComponent(rvData.Partner));
  if (isPresent(rvData.Channel)) campaignDomesticData.queryParamsMap.set('Channel', encodeURIComponent(rvData.Channel));
  if (isPresent(rvData.bUnit)) campaignDomesticData.queryParamsMap.set('bUnit', encodeURIComponent(rvData.bUnit));
  if (isPresent(rvData.paidSEngine)) campaignDomesticData.queryParamsMap.set('paidSEngine', encodeURIComponent(rvData.paidSEngine));
  if (isPresent(rvData.psKeyWord)) campaignDomesticData.queryParamsMap.set('psKeyWord', encodeURIComponent(rvData.psKeyWord));
  if (isPresent(rvData.psExactKeyWord)) campaignDomesticData.queryParamsMap.set('psExactKeyWord', encodeURIComponent(rvData.psExactKeyWord));
  if (isPresent(rvData.eepValue)) campaignDomesticData.queryParamsMap.set('entryPoint', encodeURIComponent(rvData.eepValue));
};

export const setcpsRvData = (cpsRvData) => {
  if (isPresent(cpsRvData.bUnit)) campaignDomesticData.queryParamsMap.set('bUnit', encodeURIComponent(cpsRvData.bUnit));
  if (isPresent(cpsRvData.paidSEngine)) campaignDomesticData.queryParamsMap.set('paidSEngine', encodeURIComponent(cpsRvData.paidSEngine));
  if (isPresent(cpsRvData.psKeyWord)) campaignDomesticData.queryParamsMap.set('psKeyWord', encodeURIComponent(cpsRvData.psKeyWord));
  if (isPresent(cpsRvData.psExactKeyWord)) campaignDomesticData.queryParamsMap.set('psExactKeyWord', encodeURIComponent(cpsRvData.psExactKeyWord));
  if (isPresent(cpsRvData.eepValue)) campaignDomesticData.queryParamsMap.set('entryPoint', encodeURIComponent(cpsRvData.eepValue));
};

export const retrieveAndSetRVData = () => {
  const rvData = window.gctRVObject;
  if (isPresent(rvData)) {
    setRVData(rvData);
  } else if (isPresent(window.gctCpsRVObject)) {
    const cpsRvData = window.gctCpsRVObject;
    setcpsRvData(cpsRvData);
  }
};

export const retrieveAndSetProductEvents = (digitalData) => {
  if (!isPresent(digitalData)) {
    return;
  }
  const variablesMap = {};
  if (isPresent(digitalData.user) && isPresent(digitalData.user.zipCode)) {
    campaignDomesticData.icats_zipCode = digitalData.user.zipCode;
  }
  if (isPresent(digitalData.event)) {
    variablesMap.events = '';
    variablesMap.product_code = '';
    digitalData.event.forEach((event) => {
      if (isPresent(event.eventInfo) && isPresent(event.eventInfo.eventAction)
        && isPresent(event.eventInfo.eventType)) {
        variablesMap.events += `${event.eventInfo.eventAction}:${event.eventInfo.eventType}`;
      }
      if (isPresent(event.productInfo)) {
        event.productInfo.forEach((product) => {
          if (isPresent(product.pmc)) {
            campaignDomesticData.pmc = product.pmc;
          }
          if (isPresent(product.productName)) {
            variablesMap.product_code += product.productName;
          }
        });
      }
    });
  }
  if (isPresent(variablesMap.events)) campaignDomesticData.queryParamsMap.set('events', variablesMap.events);
  if (isPresent(variablesMap.product_code)) campaignDomesticData.queryParamsMap.set('product_code', variablesMap.product_code);
};

export const retrieveAndSetPageAttributes = (digitalData) => {
  if (!isPresent(digitalData)) {
    return;
  }
  if (isPresent(digitalData.page.attributes)) {
    if (isPresent(digitalData.page.attributes.appType)) campaignDomesticData.queryParamsMap.set('appType', digitalData.page.attributes.appType);
    if (isPresent(digitalData.page.attributes.appLength)) campaignDomesticData.queryParamsMap.set('appLength', digitalData.page.attributes.appLength);
    if (isPresent(digitalData.page.attributes.channel)) campaignDomesticData.queryParamsMap.set('dtm_channel', digitalData.page.attributes.channel);
    if (isPresent(digitalData.page.attributes.appDecision)) campaignDomesticData.queryParamsMap.set('appDecision', digitalData.page.attributes.appDecision);
    if (isPresent(digitalData.page.attributes.entryPoint)) campaignDomesticData.queryParamsMap.set('entryPoint', digitalData.page.attributes.entryPoint);
    else if (isPresent(digitalData.page.attributes.partner)) campaignDomesticData.queryParamsMap.set('entryPoint', digitalData.page.attributes.partner);
    if (isPresent(digitalData.page.attributes.intlinkimp)) campaignDomesticData.queryParamsMap.set('source_cd', digitalData.page.attributes.intlinkimp);
  }
};

export const retrieveAndSetPageCategory = (digitalData) => {
  if (!isPresent(digitalData)) {
    return;
  }
  if (isPresent(digitalData.page.category)) {
    if (isPresent(digitalData.page.category.primaryCategory)) {
      if (digitalData.page.category.primaryCategory.toLowerCase() === 'cardmember') campaignDomesticData.queryParamsMap.set('appLength', 'Short');
      else if (digitalData.page.category.primaryCategory.toLowerCase() === 'prospect') campaignDomesticData.queryParamsMap.set('appLength', 'Long');
    }
    if (isPresent(digitalData.page.category.subCategory2)) campaignDomesticData.queryParamsMap.set('appFlowId', encodeURIComponent(digitalData.page.category.subCategory2));
    if (isPresent(digitalData.page.category.subCategory1)) campaignDomesticData.queryParamsMap.set('bUnit', digitalData.page.category.subCategory1);
    if (isPresent(digitalData.page.pageInfo.pageName)) campaignDomesticData.queryParamsMap.set('page_name', digitalData.page.pageInfo.pageName);
    if (isPresent(digitalData.page.pageInfo.pageID)) campaignDomesticData.queryParamsMap.set('page_id', digitalData.page.pageInfo.pageID);
  }
};

export const retrieveAndSetUrls = () => {
  campaignDomesticData.queryParamsMap.set('fullurl', encodeURIComponent(decodeVeidStr(window.document.URL)));
  campaignDomesticData.queryParamsMap.set('RefURL', encodeURIComponent(decodeVeidStr(window.document.referrer)));
};

export const sendData = (gctVidVal, queryParamsMap) => {
  const url = new URL(`${campaignDomesticData.envUrl}captureevents.do`);
  queryParamsMap.forEach((value, key) => {
    if (isPresent(value)) { url.searchParams.append(key, value); }
  });
  if (isPresent(campaignDomesticData.digitalData)) {
    url.searchParams.append('nonAX_digitalDataJSON',
      encodeURIComponent(JSON.stringify(campaignDomesticData.digitalData)));
  }
  url.searchParams.append('js_source', 'cdaas_gctUS');
  const { digitalData } = campaignDomesticData;
  makeRequest(url, digitalData);
  return true;
};

export const retrievePageData = () => {
  campaignDomesticData.gctDataArr = retrieveItagData(ITAG_ARR_DOMESTIC,
    campaignDomesticData.gctDataArr);
  campaignDomesticData.gctDataArr = retrieveOmnData('', OMN_OBJ_ARR_DOMESTIC, campaignDomesticData.gctDataArr);
  campaignDomesticData.gctDataArr = retrieveOmnData('', OMN_ARR_DOMESTIC, campaignDomesticData.gctDataArr);
  if (isPresent(campaignDomesticData.gctDataArr[0])) campaignDomesticData.queryParamsMap.set('entryPoint', campaignDomesticData.gctDataArr[0]);
  if (isPresent(campaignDomesticData.gctDataArr[1])) campaignDomesticData.queryParamsMap.set('product_code', campaignDomesticData.gctDataArr[1]);
  if (isPresent(campaignDomesticData.gctDataArr[2])) campaignDomesticData.queryParamsMap.set('zipCode', campaignDomesticData.gctDataArr[2]);
  if (isPresent(campaignDomesticData.gctDataArr[3])) campaignDomesticData.queryParamsMap.set('appFlowId', encodeURIComponent(campaignDomesticData.gctDataArr[3]));
  if (isPresent(campaignDomesticData.gctDataArr[4])) campaignDomesticData.queryParamsMap.set('events', campaignDomesticData.gctDataArr[4]);
  if (isPresent(campaignDomesticData.gctDataArr[5])) campaignDomesticData.queryParamsMap.set('pmc_code', campaignDomesticData.gctDataArr[5]);
  if (isDTMLoaded()) {
    campaignDomesticData.digitalData = getDigitalData(false);
  }
  retrieveAndSetProductEvents(campaignDomesticData.digitalData);
  retrieveAndSetPageAttributes(campaignDomesticData.digitalData);
  retrieveAndSetPageCategory(campaignDomesticData.digitalData);
  retrieveAndSetRVData();
  retrieveAndSetUrls();
  return true;
};

export const processDomesticEvents = () => {
  console.log('processDomesticEvents()');
  const gctVidVal = initialize();
  const refType = getReferrerType(document.referrer, INTERNAL_DOMAINS_DOMESTIC);
  retrievePageData(gctVidVal);
  if (isPresent(gctVidVal) && triggerGCTCall(refType, campaignDomesticData.queryParamsMap.get('page_id'))) {
    campaignDomesticData.queryParamsMap.set('reftype', refType);
    sendData(gctVidVal, campaignDomesticData.queryParamsMap);
  }
  console.log('after processDomesticEvents');
  return '{"status":"success"}';
};
